export function canConfirmQuestionReview({
  loading = false,
  questions = [],
  requireCompletionDate = true,
  targetDate = '',
} = {}) {
  return !loading
    && Array.isArray(questions)
    && questions.length > 0
    && (!requireCompletionDate || Boolean(targetDate));
}
